import React, {useState} from 'react'
import { Grid, Button, InputAdornment,IconButton, Typography, Box, Container, Card} from "@mui/material" ;
import { profileSettingStyles } from '../../../styles/materialComponent';
import { CssTextField } from '../../../styles/materialComponent';
import { resetPassword } from "../../../actions/arboristLogin"
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom"
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const UpdatePassword = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const classes = profileSettingStyles()
    const [showoldPassword, setShowOldPassword] = useState(false)
    const [shownewPassword, setShowNewPassword] = useState(false)
    const [showconfirmPassword, setShowConfirmPassword] = useState(false)
    const [error, setError] = useState("")

    const [password, setPassword] = useState({
        oldpassword:"",
        newpassword:"",
        confirmPassword:"",
    })
    
    const handleChange =(e)=>{
        const {name, value} = e.target     
        setPassword({...password, [name]:value})
    }

    const handleSubmit =(e)=>{
        e.preventDefault()
        if(password.newpassword!== password.confirmPassword){
            setError("Password and confirm does not match")
        }else{
            setError("")
            const data ={
                password:password.newpassword,
                oldpassword:password.oldpassword
            }
            dispatch(resetPassword(data, navigate))
        }       
    }

    const clear=()=>{
        setPassword({oldpassword:"",
        newpassword:"",
        confirmPassword:"",
        })
    }

  return (
      <Card
        sx={{boxShadow: "0 2px 4px 0 rgba(0,0,0,.2)", borderRadius:4, backgroundColor:"#FCFBFD", pt:8, pb:10 }}
      > 
      <Box className={classes.profileText}>
    <Typography variant="h4" fontFamily="CormorantBoldItalic">Update Password</Typography>
  </Box> 
    <Grid container spacing={2} className={classes.fields}>
     <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
      <CssTextField        
        className={classes.textField1}
        variant="outlined"
        label="Old Password"     
        name="oldpassword"
        type={showoldPassword ? "text" : "password"}
        value={password.oldpassword} 
        onChange={handleChange}   
        InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                 <IconButton
                   onClick={()=>setShowOldPassword(!showoldPassword)}
                   edge="end"
                 >
                   {showoldPassword ? <VisibilityIcon />  : <VisibilityOffIcon /> }
                 </IconButton>
               </InputAdornment>
            ) 
          }}
      />
    </Grid>
    <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
      <CssTextField     
        className={classes.textField1}
        variant="outlined"
        label="New Password"  
        name="newpassword"
        type={shownewPassword ? "text" : "password"}
        value={password.newpassword} 
        onChange={handleChange}  
        InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                 <IconButton
                   onClick={()=>setShowNewPassword(!shownewPassword)}
                   edge="end"
                 >
                   {shownewPassword ? <VisibilityIcon />  : <VisibilityOffIcon /> }
                 </IconButton>
               </InputAdornment>
            ) 
          }}     
      />
    </Grid>
     <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
      <CssTextField
        className={classes.textField1}
        variant="outlined"
        label="Confirm new password"  
        helperText={error && <p style={{color: 'red'}}>Password and confirm password do not match</p>}
        name="confirmPassword"
        type={showconfirmPassword ? "text" : "password"}
        value={password.confirmPassword} 
        onChange={handleChange}        
        InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                 <IconButton
                   onClick={()=>setShowConfirmPassword(!showconfirmPassword)}
                   edge="end"
                 >
                   {showconfirmPassword ? <VisibilityIcon />  : <VisibilityOffIcon /> }
                 </IconButton>
               </InputAdornment>
            ) 
          }}  
      />
    </Grid>         
       <Grid item xs={12} sm={12} md={6} lg={6} className={classes.grid}>
      <Button
        className={classes.submitButton1}
        style={{backgroundColor:"rgb(115 74 153)"}}
        size="large"
        variant="contained"
        onClick={handleSubmit}
      >
        Update
      </Button>
      <Button
      type="reset"
        className={classes.cancelButton1}
        style={{backgroundColor:"lightgray", color:"black", marginLeft:10}}          
        size="large"
        variant="contained"
      >
        Cancel
      </Button>
    </Grid>
    {/* </Grid>
        </Card>
        </Grid> */}
  </Grid>
  </Card>
  )
}

export default UpdatePassword